export function parseCustomerSignature(signature: string): string;
export function parseCustomerSignature(signature?: string): string | undefined;
export function parseCustomerSignature(signature?: string) {
  return signature?.replaceAll('cloud_', '');
}
